export type Choice = {
  text: string;
  value: string;
}

export function getChoiceLabel(choices: Array<Choice>, value?: string): string {
  if (!value) return "";

  const choice = choices.find(choice => choice.value === value);
  return choice?.text || value;
}
